<template>
  <ABaseModal ref="modal">
    <div class="modal">
      <div class="modal-header">
        <slot name="modal-header" />
      </div>
      <div class="modal-body">
        <slot name="modal-body" />
      </div>
      <div class="modal-captcha">
        <slot name="modal-captcha" />
      </div>
      <div class="modal-sub-footer">
        <slot name="modal-sub-footer" />
      </div>
      <div class="modal-footer">
        <template v-if="$slots['modal-footer']">
          <slot name="modal-footer" />
        </template>
        <template v-else>
          <button @click="close" class="modal-footer-button close">
            <img src="@assets/img/pop_close.svg" alt="닫기버튼" />
          </button>
        </template>
      </div>
    </div>
  </ABaseModal>
</template>
<script setup lang="ts">
import { ref, watch } from 'vue';
import { ABaseModal } from '@atoms';
import { useScrollLock } from '@composables';
import { useRouter } from 'vue-router';

const { lockScroll, unLockScroll } = useScrollLock();
defineProps({
  title: {
    type: String,
    default: 'Modal Title',
  },
  subTitle: {
    type: String,
    default: 'Modal Subtitle',
  },
});

const modal = ref();
const message = ref('');
const { currentRoute } = useRouter();
const emits = defineEmits(['close']);

const open = (msg: string) => {
  lockScroll();
  modal.value.open();
  message.value = msg;
};

const close = () => {
  unLockScroll();
  modal.value.close();
  emits('close', true);
};

watch(currentRoute, () => {
  close();
});

defineExpose({
  open,
  close,
});
</script>

<style lang="scss" scoped>
.modal {
  width: 100%;
  height: auto;
}
</style>
